import { Injectable } from '@angular/core';
import { SharedClientService } from '../components/client/shared/services/shared-client.service';


export class ClientPingService {

	public pingInstance: any;

	constructor(private sharedClientService: SharedClientService) { }

	public ping(userId: number): boolean {
		this.sharedClientService.getPingRateSeconds(String(userId)).subscribe((pingRateSeconds) => {
			let pingRateMilliSeconds = Number(pingRateSeconds) * 1000;

			this.pingInstance = setInterval(() => {
				this.sharedClientService.patchLastSeen(String(userId)).subscribe();
			}, pingRateMilliSeconds);
		});

		return true;
	}
static ctorParameters() { return [ { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/client-ping.service.ts